// extracted by mini-css-extract-plugin
module.exports = {"cards":"SeoBestProducts_cards__31GEM","gridCards":"SeoBestProducts_gridCards__2y82M","title":"SeoBestProducts_title__a0tLv"};